// extracted by mini-css-extract-plugin
var _1 = "HeaderSeparator-moduleHeaderSeparator__yvydf";
export { _1 as "HeaderSeparator" }
